"use strict";
/*
 * Created on 15.02.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * @author MSu
 */


var EntityChangeSetInfoConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(EntityChangeSetInfoConverter, _DataObjectConverter_);

  function EntityChangeSetInfoConverter() {
    _classCallCheck(this, EntityChangeSetInfoConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityChangeSetInfoConverter).apply(this, arguments));
  }

  return EntityChangeSetInfoConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.EntityChangeSetInfoConverter = EntityChangeSetInfoConverter;